// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__En6pz","d-none":"Section_d-none__FVLCu"};